import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import type { Transform } from '@dnd-kit/utilities';
import KPINumber from 'src/components/ui/KPINumber/KPINumber';
import DonutChart from 'src/components/charts/DonutChart/DonutChart';
import ValueListItem from 'src/components/layouts/ValueListItem/ValueListItem';
import './KeyValueListWithDiagramKpiCard.scss';
import { KeyValueListWithDiagramKpi } from 'src/services/kpi';
import { BadgeType } from 'src/components/ui/Badge/Badge';
import { useChartTheme } from 'src/styles/chartTheme';
import { localeNumber } from 'src/localization/locale';
import CardContainer from '../../layouts/CardContainer/CardContainer';

export const KeyValueListWithDiagramKpiCard: React.FC<{
  data: KeyValueListWithDiagramKpi;
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  setNodeRef?: (node: HTMLElement | null) => void;
  transform?: Transform | null;
  transition?: string;
}> = ({ data, attributes, listeners, setNodeRef, transform, transition }) => {
  const style = {
    transform: CSS.Transform.toString(transform || null),
    transition,
    touchAction: 'none',
  };

  const chartTheme = useChartTheme();
  const colors = [chartTheme.series[0], chartTheme.series[1], chartTheme.series[3], chartTheme.neutral];

  const dataObjects = data.value.filter(o => 'country' in o);

  const donutChartData = {
    labels: dataObjects.map(item => item.country),
    datasets: [
      {
        data: dataObjects.map(item => item.percentage),
        backgroundColor: dataObjects.map((_, index) => colors[index % colors.length]),
      },
    ],
  };

  const totalsValue = data.value.find(o => 'total_destination_countries' in o);

  return (
    <CardContainer
      className="destinationsCard surface-elevated"
      ref={setNodeRef}
      style={style}
      label={data.title}
      attributes={attributes}
      listeners={listeners}>
      <KPINumber value={totalsValue?.total_destination_countries?.toString() ?? ''} />
      <div className="grid grid-cols-2 gap-x-5">
        <div className="col-span-2 lg:col-span-1 flex flex-col text-left justify-center py-6">
          {dataObjects.map((item, idx) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <ValueListItem
                key={idx}
                label={item.country}
                type={BadgeType.Neutral4}
                color={colors[idx % colors.length]}
                value={`${localeNumber(Number(item.percentage), { maximumFractionDigits: 2 })} %`}
              />
            );
          })}
        </div>
        <div className="col-span-2 lg:col-span-1 donut-container flex justify-end">
          <div>
            <DonutChart data={donutChartData} />
          </div>
        </div>
      </div>
    </CardContainer>
  );
};

export default KeyValueListWithDiagramKpiCard;
